module.exports = __webpack_public_path__ + "static/media/nuo.51ecc8ee.svg";